import supabase from './Supabase';

export async function getFavorite(file_id: string, user_id: string) {
  const { data, error } =
    await supabase
      .from('user_favorites')
      .select()
      .eq('user_id', user_id)
      .eq('file_id', file_id)
      .maybeSingle();

  if (!data || error) {
    return null;
  }

  return data;
}

export async function saveFavorite(file_id: string, user_id: string, table = 'user_favorites') {
    const { error } =
        await supabase
            .from(table)
            .insert({user_id, file_id})

    if (error) {
        return false;
    }
    return true;
}

export async function removeFavorite(file_id: string, user_id: string, table = 'user_favorites') {
    const { error } =
        await supabase
            .from(table)
            .delete()
            .eq('user_id', user_id)
            .eq('file_id', file_id)
  if (error) {
    return false;
  }
  return true;
}

export async function getAllUserFavorites(user_id: string) {
    const { data, error } = await supabase
      .from("user_favorites")
      .select("*, files!inner(*)")
      .eq("user_id", user_id)
      .eq("files.record_deleted", false)
      .order('created_at', { ascending: false });

      if(error){
        console.warn("[DEBUG] Unable to get user favorites");
      } else {
        return data;
      }
  }